module.exports = "/static/assets/28f7d455e15b9e459aec9824ec85f346.png";